module.exports = __webpack_public_path__ + "static/media/tamara-mueller.c065ffe5.jpg";